// extracted by mini-css-extract-plugin
module.exports =  {"layout":"KeyboardLayout-Ufo1__layout","key-group":"KeyboardLayout-mb5a__key-group","key":"KeyboardLayout-FKB4__key","key--actived":"KeyboardLayout-Tm4___key--actived"};